import React from 'react';
import { ConfigProvider, Input, message, Modal } from 'antd';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
import Colors from 'enums/Colors';
import { useContext, useEffect, useState } from 'react';
import logoHumane from '../assets/logoHumane.svg';
import Select from 'components/Select';
import { ButtonHomeSolftBlueV2, ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import useUserData from 'hooks/useUserData';
import { ProfileService } from 'core/http/service/Profile.service';
import keycloak from 'core/config/keycloak';
import { AcessoExclusivoContext } from 'pages/acessoExclusivo/context/AcessoExclusivoContext';
import useFetch from 'hooks/useFetch';
import PerfilAtualizationDTO from 'models/perfil/PerfilAtualizationDTO';
import EmailVinculo from 'models/email/EmailVinculo';

const ModalSchool = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const { loadData } = useUserData();
    const { getUserExistBySchool, setGetUserExistBySchool } = useContext(AcessoExclusivoContext.Context);
    const [schoolSelected, setSchoolSelected] = useState<any>({});
    const [userSchools, setUserSchools] = useState<any[]>([]);
    const [notFoundSchool, setNotFoundSchool] = useState<boolean>(false);
    const [notCPF, setNotCPF] = useState<boolean>(false);
    const [schoolName, setSchoolName] = useState<string>('');

    const [cpfIsVinculado, setCpfIsVinculado] = useState<boolean>(false);
    const [emailVinculado, setEmailVinculado] = useState<string>('');
    const [loadingWaitEmail, setLoadingWaitEmail] = useState<boolean>(false);

    const [values, setValues] = useState({
        cpf: '',
    });

    const [loading, setLoading] = useState<boolean>(false);

    const is700x = IsCustomMaxWidth(700);

    const profileService = new ProfileService();

    const success = (message: string, delay?: number) => {
        messageApi.open({
            type: 'success',
            content: message,
            duration: delay,
        });
    };
    const error = (message: string, delay?: number) => {
        messageApi.open({
            type: 'error',
            content: message,
            duration: delay,
        });
    };

    const handleSaveUserSchool = async () => {
        if (notFoundSchool && schoolName.length === 0) return error('Informe uma escola!');
        if (!notFoundSchool && schoolSelected && !schoolSelected.schoolName) {
            return error('Informe uma escola!');
        }
        setLoading(true);
        try {
            const { usuarioLogado, perfilUsuario } = await loadData();
            if (usuarioLogado) {
                let vincularCPF = false;
                try {
                    if (notCPF && perfilUsuario?.username) {
                        const response = await profileService.atualizarCPFPerfil(perfilUsuario.username, values.cpf);
                        if (response.status == 409) {
                            error('CPF já cadastrado no sistema.');
                            setCpfIsVinculado(true);
                            setEmailVinculado(response.data.error);
                            vincularCPF = true;
                        }
                    }
                    const name = notFoundSchool ? schoolName : schoolSelected.schoolName;
                    const inep = notFoundSchool ? null : schoolSelected.schoolInep;
                    const { status } = await profileService.saveUserSchool(name, inep);
                    if (vincularCPF) return;
                    if (status === 200) {
                        success('Informações vinculadas com sucesso!');
                        setGetUserExistBySchool(false);
                    }
                } catch (err) {
                    error('Erro ao salvar informações. Tente novamente.');
                    console.error('Erro ao salvar informações:', err);
                }
            }
        } finally {
            setLoading(false);
        }
    };

    const sendEmailToConfirmCPF = async () => {
        if (keycloak.authenticated) {
            setLoadingWaitEmail(true);
            setLoading(true);
            try {
                const body: EmailVinculo = new EmailVinculo().fromJSON({
                    cpf: values.cpf,
                    redirectUrl: window.location.href,
                });
                const { status } = await profileService.sendEmailToConfirmCPF(body);
                if (status === 200) {
                    success('E-mail enviado com sucesso!');
                } else {
                    error('Erro ao enviar e-mail.');
                }
            } catch (err) {
                error('Erro ao enviar e-mail. Tente novamente.');
                console.error('Erro ao enviar e-mail:', err);
            } finally {
                setLoading(false);
                setLoadingWaitEmail(false);
            }
        }
    };

    const getUserSchools = async () => {
        if (keycloak.authenticated) {
            setLoading(true);
            try {
                const { data, status }: any = await profileService.findSchools();
                if (status === 200) {
                    setUserSchools(data);
                }
            } catch (err) {
                //error('Erro ao buscar escolas na sua região.');
                console.error('Erro ao buscar escolas:', err);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleZendeskWidget = () => {
        window.open('https://institutoayrtonsenna5795.zendesk.com/hc/pt-br/requests/new', '_blank');
    };

    const verifyCPFVinculated = async () => {
        const { perfilUsuario } = await loadData();

        if (keycloak.authenticated && perfilUsuario?.username) {
            const { data, status } = await profileService.findByUsername(perfilUsuario.username);

            if (data.cpf === null && status === 200) {
                error('Contas não vinculadas, por favor verifique seu e-mail e clique no botão "Vincular agora".');
            } else {
                success('Contas vinculadas com sucesso!');
                setNotCPF(false);
                setGetUserExistBySchool(false);
            }
        }
    };

    useFetch(async () => {
        const { perfilUsuario } = await loadData();

        if (keycloak.authenticated && perfilUsuario?.username) {
            const { data, status } = await profileService.findByUsername(perfilUsuario.username);

            if (data.cpf === null && status === 200) {
                setNotCPF(true);
            }
        }
    }, [loadData]);

    useEffect(() => {
        getUserSchools();
    }, []);

    return (
        <Modal
            confirmLoading={loading}
            onCancel={() => setGetUserExistBySchool(false)}
            width={700}
            open={getUserExistBySchool}
            closeIcon={true}
            maskClosable={true}
            footer
        >
            <ConfigProvider
                input={{
                    style: {
                        height: 72,
                        fontSize: 22,
                    },
                }}
            >
                {contextHolder}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: is700x ? '' : '28px 66px' }}>
                    <span style={{ color: Colors.SoftBlue, fontWeight: 500, fontFamily: 'Barlow', fontSize: 16 }}>Acesso a plataforma</span>
                    <img src={logoHumane} alt="logo-humane" style={{ width: '176px' }} />
                    {loadingWaitEmail && (
                        <p style={{ fontSize: '18px' }}>
                            {loading
                                ? 'Enviando e-mail, aguarde...'
                                : 'E-mail enviado! Verifique sua caixa de entrada para confirmar o vínculo das contas. (Pode levar alguns minutos para o recebimento do e-mail)'}
                        </p>
                    )}
                    {cpfIsVinculado && !loadingWaitEmail && (
                        <>
                            <p
                                style={{ maxWidth: '445px' }}
                                dangerouslySetInnerHTML={{
                                    __html: `<b> O CPF informado já está vinculado a outra conta.</b><br />
                                    Deseja associar este CPF à sua conta atual também?`,
                                }}
                            />

                            <p
                                style={{ maxWidth: '445px' }}
                                dangerouslySetInnerHTML={{ __html: `Se sim, será necessário confirmar essa ação por e-mail.` }}
                            />
                            <p style={{ maxWidth: '445px' }} dangerouslySetInnerHTML={{ __html: `E-mail: <b>${emailVinculado}</b>` }} />
                        </>
                    )}
                    {notCPF && !cpfIsVinculado && !loadingWaitEmail && (
                        <>
                            <p style={{ maxWidth: '445px' }} dangerouslySetInnerHTML={{ __html: `Informe abaixo seu CPF:` }} />
                            <Input
                                placeholder="Digite seu CPF."
                                value={values.cpf}
                                onChange={e => setValues(prev => ({ ...prev, cpf: e.target.value }))}
                                style={{ height: 48, fontSize: 22 }}
                            />
                        </>
                    )}
                    <p
                        style={{ maxWidth: '445px' }}
                        dangerouslySetInnerHTML={{ __html: `Selecione abaixo o nome da escola na qual você atua:` }}
                    />
                    {!notFoundSchool ? (
                        <>
                            <Select
                                itens={[
                                    { label: 'NÃO ATUO EM NENHUMA ESCOLA', value: '' },
                                    ...(Array.isArray(userSchools)
                                        ? userSchools.map(dados => ({
                                              label: dados.name,
                                              value: dados.inep,
                                          }))
                                        : []),
                                ]}
                                onSelected={selected => {
                                    setSchoolSelected({ schoolName: selected.label, schoolInep: selected.value });
                                }}
                                isSmall={false}
                                width="100%"
                            />
                            <p
                                style={{ maxWidth: '650px' }}
                                dangerouslySetInnerHTML={{
                                    __html: `Caso não encontre sua escola, clique no botão "Não encontrei minha escola" e escreva o nome da escola por extenso.`,
                                }}
                            />
                            <a
                                onClick={() => setNotFoundSchool(true)}
                                style={{
                                    color: Colors.DarkBlue3,
                                    fontWeight: 500,
                                    fontFamily: 'Barlow',
                                    fontSize: 16,
                                    textAlign: 'center',
                                    textDecoration: 'underline',
                                }}
                            >
                                Não encontrei minha escola
                            </a>
                        </>
                    ) : (
                        <Input
                            placeholder="Digite o nome da sua escola."
                            value={schoolName}
                            onChange={e => setSchoolName(e.target.value)}
                            size={'large'}
                        />
                    )}
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'center' }}>
                        {cpfIsVinculado && !loadingWaitEmail ? (
                            <>
                                <ButtonHomeV2
                                    onClick={sendEmailToConfirmCPF}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                    {loading ? <div className="loaderConteudo" /> : 'Confirmar'}
                                    {loading && 'Aguarde'}
                                </ButtonHomeV2>
                                <ButtonHomeSolftBlueV2
                                    onClick={() => setCpfIsVinculado(false)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: Colors.Yellow2,
                                        borderColor: Colors.Yellow2,
                                    }}
                                >
                                    {loading ? <div className="loaderConteudo" /> : 'Editar CPF'}
                                    {loading && 'Aguarde'}
                                </ButtonHomeSolftBlueV2>
                                <ButtonHomeSolftBlueV2
                                    onClick={handleZendeskWidget}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                    {loading ? <div className="loaderConteudo" /> : 'Fale com o suporte'}
                                    {loading && 'Aguarde'}
                                </ButtonHomeSolftBlueV2>
                            </>
                        ) : !loadingWaitEmail ? (
                            <ButtonHomeV2
                                onClick={handleSaveUserSchool}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                                {loading ? <div className="loaderConteudo" /> : 'Confirmar'}
                                {loading && 'Aguarde'}
                            </ButtonHomeV2>
                        ) : (
                            <ButtonHomeV2
                                onClick={() => verifyCPFVinculated()}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                                {loading ? <div className="loaderConteudo" /> : 'Já vinculei minhas contas'}
                                {loading && 'Aguarde'}
                            </ButtonHomeV2>
                        )}
                    </div>
                </div>
            </ConfigProvider>
        </Modal>
    );
};

export default ModalSchool;
